import { UserSubscriptionProvider, routes } from "@songtradr-one/shared-common";
import { staticText } from "../../../../../shared/statics/static-text";

// TEXT
export const text = staticText.appHeader.userMenu.subscription;

// STYLES

// DATA

// TYPES
export type Props = {
  companyName?: string;
  planName?: string | null;
  manageUrl?: string | null;
  canSubscribe?: boolean;
  onOpen: () => void;
};

// CONSTANTS
/** Where each billing system lets an org without an active plan subscribe. */
export const subscribeRoutes: Record<UserSubscriptionProvider, string> = {
  [UserSubscriptionProvider.LegacyMarketplace]: routes.distribution.subscribe,
};

// FUNCTIONS

// ASSETS
